module.exports = __webpack_public_path__ + "static/media/citadel_default.58cf22dd.jpg";